import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c476c56a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "mark star"
}
const _hoisted_3 = ["src"]


export default /*#__PURE__*/_defineComponent({
  props: {
    mark: { type: [Boolean, String] }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (__props.mark)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (__props.mark === true)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2))
          : (_openBlock(), _createElementBlock("img", {
              key: 1,
              class: "mark",
              src: __props.mark
            }, null, 8, _hoisted_3))
      ]))
    : _createCommentVNode("", true)
}
}

})